module.exports = {
      id: "ic-delete-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-dd6387.smartcharts.svg#ic-delete-usage",
      toString: function () {
        return this.url;
      }
    }